import { ArrowUpRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Wordmark } from "@/components/Nav";

const LINKS = [
  ["Contact", "/#contact"],
];

export default function Footer() {
  const lenis = useLenis();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (e, href) => {
    e.preventDefault();
    if (href === "/about") {
      navigate("/about");
      return;
    }
    const hash = href.slice(1);
    if (pathname !== "/") navigate("/" + hash);
    else if (lenis) lenis.scrollTo(hash, { offset: -64, duration: 1.4 });
  };

  return (
    <footer data-testid="site-footer" className="border-t border-ink/10 bg-paper">
      <div className="mx-auto max-w-[1500px] px-6 py-16 md:px-10 lg:px-14">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Wordmark />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-dim">
              Company-facing creator partnerships for B2B companies moving at the speed of AI.
            </p>
            <div className="mt-8 border-t border-ink/10 pt-6">
              <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-ink">Lennon Management</p>
              <p className="mt-2 text-sm leading-relaxed text-dim">
                Creator-facing management, partnerships and business development.
              </p>
              <a
                href="https://www.lennonmgmt.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-lennonmgmt-link"
                className="group mt-3 inline-flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.12em] text-accent transition-colors duration-300 hover:text-ink"
              >
                lennonmgmt.com
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="mb-5 text-[12px] font-bold uppercase tracking-[0.18em] text-dim">Navigate</p>
            <ul className="space-y-3">
              {LINKS.map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    onClick={(e) => go(e, href)}
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm font-semibold text-ink/70 transition-colors duration-300 hover:text-accent"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3 md:col-start-10">
            <p className="mb-5 text-[12px] font-bold uppercase tracking-[0.18em] text-dim">Contact</p>
            <a
              href="https://www.linkedin.com/in/naomilennon"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className="block text-sm font-semibold text-ink/70 transition-colors duration-300 hover:text-accent"
            >
              LinkedIn — Naomi Lennon
            </a>
            <a
              href="mailto:naomi@lennonmgmt.com"
              data-testid="footer-email-link"
              className="mt-3 block text-sm font-semibold text-ink/70 transition-colors duration-300 hover:text-accent"
            >
              naomi@lennonmgmt.com
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-ink/10 pt-6 text-[11px] font-bold uppercase tracking-[0.18em] text-dim md:flex-row md:items-center md:justify-between">
          <span>© 2026 LENNON GLOBAL</span>
          <span>Los Angeles · Dubai · Global</span>
        </div>
      </div>
    </footer>
  );
}
